import { useNavigate } from 'react-router';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { useSession } from '@/app/session';

/** «Nueva solicitud» de Inicio y la bandeja. Sin `case.create` no aparece. */
export function NewCaseButton() {
  const nav = useNavigate();
  const { can } = useSession();
  if (!can('case.create')) return null;
  return <Button size="sm" onClick={() => nav('/pqrs/nueva')}><Icono nombre="mdi:plus" /> Nueva solicitud</Button>;
}
